import { useState, useEffect } from "react";
import axios from "axios";
import { CONTENT_ROUTES } from "../routes/content-routes";

export const useGalleryData = (gallerySlug) => {
  const [gallery, setGallery] = useState({});
  const [page, setPage] = useState({});
  const [pageMedia, setPageMedia] = useState([]);
  const [galleryMedia, setGalleryMedia] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!gallerySlug) return;

    const fetchData = async () => {
      try {
        setLoading(true);
        
        const pageResponse = await axios.get(CONTENT_ROUTES.POST_PAGE("/pages", "gallery"));
        const pageData = pageResponse.data?.length ? pageResponse.data[0] : {};
        setPage(pageData);

        if (pageData?.id) {
          const pageMediaResponse = await axios.get(CONTENT_ROUTES.MEDIA_BY_PAGE(pageData.id));
          setPageMedia(pageMediaResponse.data);
        }

        const galleryResponse = await axios.get(
          CONTENT_ROUTES.GALLERIES("?slug=" + gallerySlug)
        );
        const galleryData = galleryResponse.data?.length ? galleryResponse.data[0] : {};
        setGallery(galleryData);

        if (galleryData?.id) {
          const galleryMediaResponse = await axios.get(CONTENT_ROUTES.MEDIA_BY_PAGE(galleryData.id));
          setGalleryMedia(galleryMediaResponse.data);
        }

      } catch (err) {
        setError(err);
        console.error("Error fetching gallery data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [gallerySlug]);

  return {
    gallery,
    page,
    pageMedia,
    galleryMedia,
    loading,
    error
  };
};